export { ClickAndCollectInfoModalButton } from './ClickAndCollectInfoModalButton'
